import { render, staticRenderFns } from "./TimelinePermissions.vue?vue&type=template&id=98c2fb42&scoped=true&"
import script from "./TimelinePermissions.vue?vue&type=script&lang=ts&"
export * from "./TimelinePermissions.vue?vue&type=script&lang=ts&"
import style0 from "./TimelinePermissions.vue?vue&type=style&index=0&id=98c2fb42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c2fb42",
  null
  
)

export default component.exports